import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

import { noteId, type NoteId } from './Note.js'
import { notificationId, type NotificationId } from './Notification.js'

/** Represents the table public.notification_note_ */
export default interface NotificationNoteTable {
  /** Database type: pg_catalog.uuid */
  noteId: ColumnType<NoteId, NoteId, NoteId>

  /** Database type: pg_catalog.uuid */
  notificationId: ColumnType<NotificationId, NotificationId, NotificationId>
}

export type NotificationNote = Selectable<NotificationNoteTable>

export type NotificationNoteInitializer = Insertable<NotificationNoteTable>

export type NotificationNoteMutator = Updateable<NotificationNoteTable>

export const notificationNote = z.object({
  noteId: noteId,
  notificationId: notificationId,
}) as unknown as z.Schema<NotificationNote>

export const notificationNoteInitializer = z.object({
  noteId: noteId,
  notificationId: notificationId,
}) as unknown as z.Schema<NotificationNoteInitializer>

export const notificationNoteMutator = z.object({
  noteId: noteId.optional(),
  notificationId: notificationId.optional(),
}) as unknown as z.Schema<NotificationNoteMutator>
